var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#79EEF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 0.5,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#D35258"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 0.558594,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#F7C12C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#5B9EE9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#C94951"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#E36630"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 15.5,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#4273B0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 15.5,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#9862C1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15.5,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#B962C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ca6946c654c742b7e05b0df301df38f5.svg";
export { ForwardRef as ReactComponent };